module.exports = __webpack_public_path__ + "static/media/SA_horizontal_couleur_HR.91c94d12.png";